import { ToolsTranslations } from '@/lib/translations/types';

export interface RodValues { netIncome: number; longTermDebtStart: number; longTermDebtEnd: number }
export interface RodResult { percent: number | null; isValid: boolean; message?: string }

// ROD (%) = Net income / Average long-term debt * 100
export function calculateRod(values: RodValues, t?: ToolsTranslations['rod']): RodResult {
  const { netIncome, longTermDebtStart, longTermDebtEnd } = values;
  if (netIncome < 0) return { percent: null, isValid: false, message: t?.invalid.netIncome };
  if (longTermDebtStart < 0) return { percent: null, isValid: false, message: t?.invalid.longTermDebtStart };
  if (longTermDebtEnd < 0) return { percent: null, isValid: false, message: t?.invalid.longTermDebtEnd };
  const averageDebt = (longTermDebtStart + longTermDebtEnd) / 2;
  if (averageDebt <= 0) return { percent: null, isValid: false, message: t?.invalid.averageDebtNonPositive };
  const percentRaw = (netIncome / averageDebt) * 100;
  const percent = Math.round(percentRaw * 100) / 100; // 2 decimals
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


